import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=3edb022e&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"
import style0 from "./Languages.vue?vue&type=style&index=0&id=3edb022e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb022e",
  null
  
)

export default component.exports